module.exports = __webpack_public_path__ + "img/CSS3 Knowledge Today_Silicon Stone Education_20200906.44aaa59f.jpg";